import React, { useEffect, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CountItem from "./countItem";
import Chart from "chart.js";

import { assignmentBarOptions, countTasks, convertToChartDatasets } from "./lib/constants";

const TaskItem = ({ taskDefinition, data, taskKey }) => {
    const counts = useMemo(() => {
        return Object.keys(data.states)
            .sort((a, b) => countTasks.indexOf(a) - countTasks.indexOf(b))
            .reduce((arr, key) => {
                if (countTasks.includes(key)) {
                    arr.push(
                        <CountItem
                            key={key}
                            stateKey={key}
                            value={data.states[key]}
                        />
                    );
                }

                return arr;
            }, []);
    }, [data]);

    useEffect(() => {
        const companyList = [];
        const statusList = Object.keys(data.states).map((key) => key);
        const barData = Object.keys(data.assignments).reduce((obj, aKey) => {
            const assignment = data.assignments[aKey];
            const activeCount = assignment.states["active"] || assignment.states["open"] || 0;
            companyList.push([assignment.name, `(${activeCount})`]);

            // Interate through all available states
            statusList.forEach((state) => {
                if (!obj.hasOwnProperty(state)) {
                    obj[state] = [];
                }

                obj[state].push(assignment.states[state] || 0);
            });

            return obj;
        }, {});

        if (taskKey !== "scheduling") {
            var ctx = document.getElementById(taskKey).getContext("2d");
            new Chart(ctx, {
                type: "horizontalBar",
                // The data for our dataset
                data: {
                    labels: companyList,
                    datasets: convertToChartDatasets(barData),
                },
                options: assignmentBarOptions,
            });
        }
    }, []);

    return (
        <div>
            <h3>
                <FontAwesomeIcon
                    className="m-r-12"
                    icon={taskDefinition.icon}
                />
                {taskDefinition.label}
            </h3>
            <div className="counts">{counts}</div>
            <canvas
                id={taskKey}
                height="100"
            />
        </div>
    );
};

export default TaskItem;
